import * as React from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { EmployeeFilterOptionFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import { getFullDisplayName } from 'modules/core/lib/userDisplayName'
import { type Users } from 'modules/core/store/collections/users'

import { type Employees } from 'modules/employees/store/collections/employees'

type NameWithAvatarProps = {
  name: string
  avatarUrl?: string
}

const NameWithAvatar = ({ name, avatarUrl }: NameWithAvatarProps) => {
  return (
    <Box gap="s8" flexDirection="row" alignItems="center">
      <Avatar label={name} url={avatarUrl} size="s32" />
      <Text.Normal ellipsis size="300">
        {name}
      </Text.Normal>
    </Box>
  )
}

export type EmployeeOption = {
  label: string
  value: string
  component: React.ReactNode
}

/**
 * Creates employee filter options from GraphQL data
 */
export const makeEmployeeOptionsFromGraphQL = (
  employees: EmployeeFilterOptionFragment[]
): EmployeeOption[] =>
  employees.map((employee) => {
    const name = employee.fullName
    const avatar = employee.access?.avatar

    return {
      label: name,
      value: employee.id,
      component: <NameWithAvatar name={name} avatarUrl={buildUrl(avatar)} />,
    }
  })

/**
 * Creates employee filter options from legacy MobX collections
 * @deprecated Use makeEmployeeOptionsFromGraphQL instead
 */
export const makeEmployeeOptions = (employees: Employees, users: Users) =>
  employees.map((employee) => {
    const user = users.get(employee.attributes.access_id)
    if (!user) {
      throw new Error(`User not found for employee ${employee.id}`)
    }

    const name = getFullDisplayName({
      firstName: user.attributes.first_name,
      lastName: user.attributes.last_name,
      canSharePreferredName: employee.policy.can('sharePreferredName'),
      preferredName: employee.attributes.preferred_name,
    })
    const avatar = user.avatar

    return {
      label: name,
      value: employee.id,
      component: <NameWithAvatar name={name} avatarUrl={buildUrl(avatar)} />,
    }
  })
